import '../scss/cart/_index.scss'

import { initNewCustomerDiscount } from './cart/new-customer-discount.js'
import './cart/sticky-button.js'
import './cart/quotation-request.js'

let cartChanged = false

const dispatchCartViewed = () => {
  if (!document.querySelector('[data-ecommerce-summary]')) {
    return
  }

  window.dispatchEvent(new CustomEvent('cart.viewed'))
}

const initCartShareCopy = () => {
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) {
      return
    }

    const button = event.target.closest('[data-cart-share-copy]')

    if (!(button instanceof HTMLButtonElement)) {
      return
    }

    const input = document.querySelector('#shared-cart-url')

    if (!(input instanceof HTMLInputElement)) {
      return
    }

    const originalHtml = button.innerHTML

    try {
      await navigator.clipboard.writeText(input.value)
      button.innerHTML = `<i class="bi bi-check-lg me-1"></i>${button.dataset.doneLabel ?? ''}`

      window.setTimeout(() => {
        button.innerHTML = originalHtml
      }, 2000)
    } catch (error) {
      console.error(error)
    }
  })
}

window.addEventListener('cart.updated', () => {
  cartChanged = true
})

document.addEventListener('click', (event) => {
  const target = event.target

  if (!(target instanceof Element)) {
    return
  }

  const checkout = target.closest('[data-checkout-start]')

  if (!(checkout instanceof HTMLElement)) {
    return
  }

  window.dispatchEvent(new CustomEvent('checkout.started'))
})

document.querySelector('[data-remote-modal]')?.addEventListener('hidden.bs.modal', () => {
  if (!cartChanged) {
    return
  }

  window.location.reload()
})

const initCart = () => {
  dispatchCartViewed()
  initCartShareCopy()
  initNewCustomerDiscount()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCart, { once: true })
} else {
  initCart()
}
